import { RenderLeafProps } from 'slate-react';

type DiffedLeafProps = RenderLeafProps & {
  side?: 'left' | 'right';
  renderLeaf: (leafProps: RenderLeafProps) => JSX.Element;
};

const DiffedLeaf = (props: DiffedLeafProps) => {
  const { renderLeaf, leaf } = props;
  const highlight = (leaf as { highlight?: string }).highlight;

  if (highlight) {
    return <span className={`diffed-change-${highlight}`}>{renderLeaf(props)}</span>;
  }

  return renderLeaf(props);
};

export default DiffedLeaf;
